import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import uuidv4 from 'uuid';
import PropTypes from 'prop-types';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Typography } from '@material-ui/core';

import NeuriteGrid from '../../components/neurite_grid';

//actions:
import { getContabCentro, modifyContabCentro, addContabCentro, removeContabCentro } from '../../actions/contab_centro_actions';
import { getTiposZonasIva } from '../../actions/zona_iva_centro_actions';
import { openDialog, hideDialog, setSaveState } from '../../actions';


const styles = theme => ({
    title: {
        margin: '5px 10px',
    },
    spinnerContainer: {
        width: '95%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
});


class CentroContab extends React.Component {

    modifyContabCentro = contab => {
        this.props.setSaveState(true);
        this.props.modifyContabCentro(contab);
    };

    addContabCentro = contab => {
        this.props.setSaveState(true);
        this.props.addContabCentro(contab);
    };

    messageError = error => {

        this.props.openDialog('SimpleMessage', {
            message: error
        }, uuidv4(), false, 'sm');

    };

    checkContab = contab => {

        if (this.props.contabCentro.find(c => (c.iTipoMaquina === contab.iTipoMaquina) && (c.id !== contab.id))) {
            this.messageError(`Ya existe una contabilidad para la máquina ${contab.tipoMaquina}`);
            return false;
        } else if (contab.fIni < '1900-01-01T00:00:00') {
            this.messageError('Fecha de inicio inválida');
            return false;
        } else if (contab.fEnd && contab.fIni > contab.fEnd) {
            this.messageError('Fecha de fin debe ser posterior a la de inicio');
            return false;
        } else if(contab.fEnd && contab.fEnd > '2079-06-06T00:00:00') {
            this.messageError('Fecha de fin debe ser anterior al año 2079');
            return false;
        }

        else return true;

    };

    editContab = contab => {
        this.props.openDialog('EditContabCentro', {
            contabCentro: contab,
            tiposMaquina: this.props.tiposMaquina,
            tiposZonaIva: this.props.tiposZonaIva,
            okHandler: this.modifyContabCentro,
            checkContab: this.checkContab,
            centroid: this.props.centroid
        }, uuidv4());
    };

    newContab = () => {

        this.props.openDialog('EditContabCentro', {
            contabCentro: {},
            tiposMaquina: this.props.tiposMaquina,
            tiposZonaIva: this.props.tiposZonaIva,
            okHandler: this.addContabCentro,
            checkContab: this.checkContab,
            centroid: this.props.centroid
        }, uuidv4());
    };

    removeContab = contab => {
        this.props.setSaveState(true);
        this.props.removeContabCentro(contab);
    };

    componentDidMount() {

        this.props.getContabCentro(this.props.centroid);

    };

    render() {

        const { classes } = this.props;

        return (
            <div >
                <Typography variant="h6" className={classes.title} color={'primary'}>Contabilidad</Typography>
                {this.props.contabCentro && !this.props.isLoading ?
                    <NeuriteGrid
                    id="c_c"
                        columns={[
                            { key: 'tipoMaquina', name: 'Tipo de máquina', editable: false, dragable: false, width: 140, },
                            { key: 'zonaIva', name: 'Tipo Zona IVA', tooltip: 'Zona de IVA que ofrece a cada tipo de máquina', editable: false, dragable: false, width: 105 },
                            { key: 'ctaDebe', name: 'Debe', tooltip: 'Cuenta corriente asociado a este tipo de maquina en este centro', editable: false, dragable: false, width: 75 },
                            { key: 'ctaHaber', name: 'Haber', tooltip: 'Cuenta corriente asociado a este tipo de maquina en este centro', editable: false, dragable: false, width: 75 },
                            { key: 'ctaIva', name: 'IVA', tooltip: 'Cuenta corriente asociada al IVA para este tipo de máquina', editable: false, dragable: false, width: 75 },
                            { key: 'fIni', name: 'Fecha inicio', tooltip: 'Fecha de inicio de validez del IVA y cuentas', editable: false, dragable: false, width: 80, type: 'date' },
                            { key: 'fEnd', name: 'Fecha fin', tooltip: 'Fecha de fin de validez del IVA y cuentas',  editable: false, dragable: false, width: 80, type: 'date' },
                        ]}
                        rows={this.props.contabCentro.filter(c => c.centroId === this.props.centroid)}
                        buttonEdit={true}
                        buttonDelete={true}
                        buttonNew={true}
                        onNewRowClick={this.newContab}
                        onEditClick={this.editContab}
                        onDeleteClick={this.removeContab}
                        height={200}
                    />
                    : <div className={classes.spinnerContainer}> <CircularProgress className={classes.spinner} color="primary" /> </div>}
            </div>
        );

    };

};

CentroContab.propTypes = {
    //state
    contabCentro: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    tiposMaquina: PropTypes.array.isRequired,
    tiposZonaIva: PropTypes.array.isRequired,
    //dispatch
    openDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    getContabCentro: PropTypes.func.isRequired,
    modifyContabCentro: PropTypes.func.isRequired,
    addContabCentro: PropTypes.func.isRequired,
    removeContabCentro: PropTypes.func.isRequired,
    //parameters
    centroid: PropTypes.number.isRequired,
};

function mapStateToProps(state) {
    return {
        contabCentro: state.contabCentro.contabCentro,
        isLoading: state.contabCentro.isLoading,
        tiposMaquina: state.tiposMaquina.tiposmaquina,
        tiposZonaIva: state.tiposZonaIva,
    };
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        openDialog: openDialog,
        hideDialog: hideDialog,
        getContabCentro: getContabCentro,
        modifyContabCentro: modifyContabCentro,
        addContabCentro: addContabCentro,
        removeContabCentro: removeContabCentro,
        getTiposZonasIva,
        setSaveState
    }, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(CentroContab));